import React from "react";
import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form-factory";

import { Wrapper, FormCard } from "./styles";
import { GroupProp } from "../../../../components/form-factory/utils/util";

type PageProps = {
  groups: GroupProp[];
  onSubmit: (values: any) => void;
  initialData?: any;
};

const IssEditPage: React.FC<PageProps> = ({
  groups,
  onSubmit,
  initialData,
}) => (
  <Wrapper>
    <BackButtom text={initialData?.id ? "Editar ISS" : "Novo ISS"} />
    <FormCard>
      <FormFactory
        groups={groups}
        onSubmit={onSubmit}
        button={{
          submit: initialData?.id ? "Salvar Alterações" : "Criar ISS",
          submitting: "Processando...",
        }}
      />
    </FormCard>
  </Wrapper>
);

export default IssEditPage;
